<div class="position-relative">
  <div>
    @for (star of emptyStars; track $index) {
      <fa-icon class="empty-star h5" [icon]="star"></fa-icon>
    }
  </div>
  <div class="position-absolute star-container">
    @for (star of fullStars; track $index) {
      <fa-icon class="filled-star h5" [icon]="star"></fa-icon>
    }
    @if (showHalfStar) {
      <fa-icon class="filled-star h5" [icon]="['fas', 'star-half']"></fa-icon>
    }
  </div>
</div>
